'use client'

import React from 'react'
import OfferOutUrl from '@/components/shared/OfferOutUrl'
import { ArrowRight } from 'lucide-react'

interface Props {
    unique_id: string; outUrl: string; merchantHref: string
    domain: string; isCoupon: boolean; couponCode?: string | null
    label?: string; className?: string
}

const OfferCTAButton = ({ unique_id, outUrl, merchantHref, domain, isCoupon, label = 'Get Deal', className = '' }: Props) => {
    const buttonText = isCoupon ? 'Get Code' : label

    return (
        <OfferOutUrl unique_id={unique_id} outUrl={outUrl} merchantHref={merchantHref} domain={domain} customClass={`w-full ${className}`}>
            <div
                className="w-full flex items-center justify-center gap-1.5 py-2 px-3 rounded-xl font-bold text-xs text-[#2D3E2D] shadow-sm hover:shadow-md transition-all duration-300 hover:scale-[1.01] cursor-pointer"
                style={{ background: 'linear-gradient(135deg, #F5C542 0%, #E5B224 100%)' }}
            >
                <span>{buttonText}</span>
                <ArrowRight size={13} />
            </div>
        </OfferOutUrl>
    )
}

export default OfferCTAButton

